module.exports = "../static/media/banner_short.ad4557b5.png";